class BookingQRCodeScannedPage {
    constructor() {
        this.wrapper = document.getElementById('booking-qr-code-scanned-page');
        if (this.wrapper) {
            this.init();
        }
    }

    init() {
        // this.bindCollapsibleSections();
        this.bindFormSubmit();
    }

    // bindCollapsibleSections() {
    //     const headers = this.wrapper.querySelectorAll('.collapsible-header');

    //     headers.forEach(header => {
    //         header.addEventListener('click', () => {
    //             const section = header.closest('.collapsible-section');
    //             const isExpanded = section.dataset.expanded === 'true';
    //             section.dataset.expanded = isExpanded ? 'false' : 'true';
    //         });
    //     });
    // }

    bindFormSubmit() {
        const forms = this.wrapper.querySelectorAll('.host-action-form');

        forms.forEach(form => {
            form.addEventListener('submit', (e) => {
                const btn = form.querySelector('button[type="submit"]');
                if (btn) {
                    btn.disabled = true;
                    btn.classList.add('loading');
                }
            });
        });
    }
}

export default BookingQRCodeScannedPage;
